import { Link } from "react-router-dom";
import { ArrowRight, FileText, Rocket, ShoppingBag, Gem, Wrench, Layers3, LayoutGrid, ShieldCheck, Grid3X3 } from "lucide-react";
export function HomePage({ primaryOnly = false }: { primaryOnly?: boolean }) {
  const routes = primaryOnly
    ? [
        { to: "/inscribe", number: "01", title: "INSCRIBE", description: "Create inscriptions directly from your wallet.", icon: FileText },
        { to: "/launchpad/launch", number: "02", title: "LAUNCH", description: "Create and manage your Bitcoin drop.", icon: Rocket },
        { to: "/launchpad", number: "03", title: "MINT", description: "Discover and mint live Bitcoin drops.", icon: ShoppingBag },
        { to: "/rare-sats", number: "04", title: "RARE SATS", description: "Discover, buy and sell notable Bitcoin sats.", icon: Gem },
        { to: "/shield", number: "05", title: "SHIELDED", description: "Mint, shield, transfer and trade Shielded Ordinals.", icon: ShieldCheck },
        { to: "/tools", number: "06", title: "TOOLS", description: "Transfer, split and manage your Bitcoin UTXOs and inscriptions.", icon: Wrench },
        { to: "/bitmaps", number: "07", title: "BITMAPS", description: "Trade Bitcoin districts. Explore the inscriptions inside each block.", icon: Grid3X3 },
      ]
    : [
        { to: "/inscribe", number: "01", title: "INSCRIBE", description: "One file, text or delegate.", icon: FileText },
        { to: "/batch", number: "02", title: "BATCH", description: "Many files, destinations and metadata.", icon: Layers3 },
        { to: "/gallery", number: "03", title: "GALLERY", description: "An on-chain gallery with an image or text cover.", icon: LayoutGrid },
      ];
  return (
    <main className="home-page">
      <section className="home-launch">
        <header className="home-launch-heading">
          <p className="eyebrow">BITCOIN ORDINALS // CHOOSE A FLOW</p>
          <h1><span>SPAM THE</span> <em>CHAIN.</em></h1>
          <p>INSCRIBE DIRECTLY FROM YOUR WALLET.</p>
        </header>
        <div className={primaryOnly ? "home-route-grid products" : "home-route-grid"} aria-label={primaryOnly ? "Choose a Spam The Chain product" : "Choose an inscription workflow"}>
          {routes.map((route) => {
            const Icon = route.icon;
            if ("disabled" in route && route.disabled) {
              return (
                <article className="home-route-card disabled" aria-disabled="true" key={route.title}>
                  <span className="home-route-number">{route.number}</span>
                  <span className="home-route-icon"><Icon /></span>
                  <span className="home-route-copy"><strong>{route.title}</strong><small>{route.description}</small></span>
                  <span className="home-route-status">COMING SOON</span>
                </article>
              );
            }
            return (
              <Link className="home-route-card" to={route.to} key={route.to}>
                <span className="home-route-number">{route.number}</span>
                <span className="home-route-icon"><Icon /></span>
                <span className="home-route-copy"><strong>{route.title}</strong><small>{route.description}</small></span>
                <ArrowRight />
              </Link>
            );
          })}
        </div>
      </section>
    </main>
  );
}
